<template>
  <v-autocomplete
    :clearable="clearable"
    v-model="taskValue"
    :items="tasks"
    :loading="isLoading"
    :rules="rules"
    :search-input="search"
    item-text="name"
    :item-value="itemValue"
    :return-object="returnObject"
    :disabled="disabled"
    :outlined="outlined"
    :label="$t('categories.project.task')"
    :dense="dense"
    :multiple="multiple"
    @input="handleInput"
  ></v-autocomplete>
</template>

<script>
import TaskService from "@/services/TaskService"
export default {
  props: {
    rules: {
      type: Array,
      default: () => []
    },
    outlined: {
      type: Boolean,
      default: false
    },
    returnObject: {
      type: Boolean,
      default: true
    },
    itemValue: {
      type: String,
      default: "pk"
    },
    dense: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: true
    },
    value: {
      default: null
    }
  },
  data() {
    return {
      search: "",
      isLoading: false,
      taskValue: null,
      tasks: []
    }
  },
  created() {
    this.getTasks()
  },
  watch: {
    value: {
      deep: true,
      handler(newValue, oldValue) {
        if (newValue) this.taskValue = newValue
      }
    }
  },
  methods: {
    getTasks() {
      this.isLoading = true
      TaskService.list(this.$store.state.app.project.id)
        .then(r => {
          this.tasks = r.results
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    handleInput() {
      const $ = this
      this.$nextTick(() => {
        $.$emit("input", this.taskValue)
      })
    }
  }
}
</script>
